import React from 'react';

class AppRuntimeBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // eslint-disable-next-line no-console
    console.error('[APP_RUNTIME_BOUNDARY] render crash captured', {
      message: error?.message || 'unknown',
      stack: errorInfo?.componentStack || null,
    });
  }

  handleReload = () => {
    if (typeof window !== 'undefined') {
      window.location.reload();
    }
  };

  render() {
    const { language = 'fr', children } = this.props;
    if (!this.state.hasError) {
      return children;
    }

    return (
      <main
        className="min-h-screen bg-[color:var(--cb-bg)] flex items-center justify-center px-4"
        style={{ minHeight: '100dvh' }}
      >
        <section className="cozy-card max-w-sm w-full p-5 text-center">
          <p className="cozy-section-kicker">
            {language === 'fr' ? 'Oups' : 'Oops'}
          </p>
          <h1 className="mt-1 text-lg font-extrabold text-[color:var(--cb-text)]">
            {language === 'fr'
              ? "L’app a besoin d’un redemarrage."
              : 'The app needs a restart.'}
          </h1>
          <p className="mt-2 text-sm text-[color:var(--cb-text-muted)]">
            {language === 'fr'
              ? "Un souci inattendu est survenu. On peut relancer proprement."
              : 'An unexpected issue occurred. You can relaunch cleanly.'}
          </p>
          <button
            type="button"
            onClick={this.handleReload}
            className="mt-4 w-full py-3 rounded-full bg-[color:var(--cb-primary)] text-white font-bold"
          >
            {language === 'fr' ? 'Relancer ColoBongo' : 'Restart ColoBongo'}
          </button>
        </section>
      </main>
    );
  }
}

export default AppRuntimeBoundary;
